<template>
  <div v-editable="blok" class="expert-card">
    <div class="expert-card__header">
      <BaseNuxtImage
        class="expert-card__photo"
        :src="(blok.photo && blok.photo.filename) || '/'"
        :alt="blok.photo && blok.photo.alt"
        loading="lazy"
      />
      <div class="expert-card__info">
        <h4 class="expert-card__name">
          {{ blok.name }}
        </h4>
        <p class="expert-card__position">
          {{ blok.position }}
        </p>
        <a v-if="blok.linkedin_link" :href="blok.linkedin_link" target="_blank">
          <img
            width="24"
            height="24"
            class="expert-card__linkedin"
            src="@/assets/icons/icon-linkedin.svg?url"
            alt="LinkedIn logo"
          />
        </a>
      </div>
    </div>
    <BaseRichText
      class="expert-card__description"
      :rich-text-template="description"
    />
  </div>
</template>

<script lang="ts" setup>
import type { SbExpertCardStoryblok } from '@/types'
interface Props {
  blok: SbExpertCardStoryblok
}
const props = defineProps<Props>()

const description = computed(() => {
  return props.blok.description !== undefined ? props.blok.description : {}
})
</script>

<style lang="scss" scoped>
.expert-card {
  margin: 0 auto;
  max-width: 660px;

  &__header {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    align-items: flex-start;

    @media (min-width: $breakpoint-md) {
      flex-direction: row;
      align-items: center;
    }
  }

  &__photo {
    width: 96px;
    height: 96px;
    border: 1px solid var(--gray-300);
    border-radius: 999px;
    margin-right: 20px;
    margin-bottom: 16px;

    @media (min-width: $breakpoint-md) {
      width: 148px;
      height: 148px;
      margin-bottom: 0;
    }
  }

  &__name {
    margin-bottom: 4px;
    color: var(--cobalt-800);
  }

  &__position {
    font-size: var(--font-size-paragraph-s);
    margin-bottom: 4px;
  }

  &__linkedin {
    width: 20px;
    height: 24px;
  }

  &__description {
    font-size: var(--font-size-paragraph-s);
    line-height: 25px;

    @media (min-width: $breakpoint-md) {
      font-size: var(--font-size-paragraph-m);
      line-height: 30px;
    }
  }
}
</style>
